export default "__VITE_ASSET__de8e9f40__"